"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _react = _interopRequireDefault(require("react"));
var _percentPart = _interopRequireDefault(require("@deosite/helpers/percentPart"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var __jsx = _react["default"].createElement;
var SoldProgressBar = function SoldProgressBar(_ref) {
  var sold = _ref.sold,
    left = _ref.left;
  var translations = {
    left: (0, _langLibrary["default"])("left hits"),
    sold: (0, _langLibrary["default"])("sold hits")
  };
  var percentWidth = !sold ? 100 : (0, _percentPart["default"])(sold, sold + left);
  percentWidth = percentWidth === 100 ? percentWidth : 100 - percentWidth;
  return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      textAlign: "center"
    }
  }, __jsx(_Box["default"], {
    sx: {
      flexBasis: "100%",
      minHeight: "4px",
      maxHeight: "4px",
      borderColor: "#CFCEC5",
      borderLeftStyle: "solid",
      borderRightStyle: "solid",
      borderWidth: "1px",
      mt: "s8",
      mb: "s6",
      bg: "#CFCEC5",
      position: "relative",
      zIndex: "1"
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: "3px",
      backgroundColor: "active",
      position: "absolute",
      zIndex: "2",
      maxWidth: "100%",
      width: percentWidth + "%",
      transition: "width 0.2s ease-out"
    }
  }))), __jsx(_Box["default"], {
    sx: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      font: "xs_caps",
      color: "white",
      textTransform: "lowercase",
      backgroundColor: "none"
    }
  }, __jsx(_Box["default"], {
    as: "span"
  }, translations.left, " ", left), __jsx(_Box["default"], {
    as: "span"
  }, translations.sold, " ", sold)));
};
var _default = SoldProgressBar;
exports["default"] = _default;